<template>
  <div class="pk-animationthumbnail-container"
   ref="container">
    <div class="pk-animationthumbnail-items">
      <div v-for="(it,i) in items" class="pk-animationthumbnail-item"
       :key="'tn' + i"
       :class="activeSlide.activeAnimationKey === i ? 'showing' : ''"
       @click="selectAnimationByIdx(i)"
       :title="it.description"
      >
        <div class="pk-animationthumbnail-item-title">{{it.name}}</div>
        <div class="pk-animationthumbnail-item-standalone-button" @click="openAnimationInStandalonePage(it, $event)"></div>
      </div>
      <div v-if="items.length < 1">no animation found</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import * as $ from 'jquery';

export default Vue.extend({
  props: {
    items: Array,
    colCount: Number,
    rowCount: Number
  },
  data() {
    return {
      selectedItem: null,
      parentHeight: 100,
      parentWidth: 100,
    };
  },
  // created() {},
  mounted() {
    const vue = this;

    const resize = () => {
      vue.parentHeight = $(vue.$refs.container).height();
      vue.parentWidth = $(vue.$refs.container).width();
    };
    window.addEventListener('resize', () => {
      resize();
    });
    resize();
  },
  // updated() {},
  watch: {
    // items() {
    //   for (let i = 0; i < this.items.length; i++) {
    //     // 
    //   }
    // }
  },
  computed: {
    thumbnailIdx() {
      const idx = this.$route.query['animationthumbnail'];
      return parseInt(idx, 10) ? parseInt(idx, 10) : 0;
    },
    viewNavItems() {
      return this.$store.getters['archive/viewNavItems'];
    },
    activeSlide() {
      return this.$store.getters['archive/activeSlide'];
    },
  },
  methods: {
    selectAnimationByIdx(i) {
      this.activeSlide.activeAnimationKey = i;
    },
    openAnimationInStandalonePage(item, event) {
      event.stopPropagation();
      const order = item.order;
      const ssid = this.$store.getters['archive/activeSlideset']._id;
      const sid = this.$store.getters['archive/activeSlide']._id;
      const url = window.location.href.replace(/\/ae\/.*/, '/ae/animation/' + ssid + '/' + sid + '/' + order);
      window.open(url, '_blank');

    },
  }
});
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variable.scss';
@import '../../assets/scss/layout.scss';
@import '../../assets/scss/color.scss';
@import '../../assets/scss/size.scss';

.pk-animationthumbnail-container {
  width: 100%;
  height:100%;
  overflow: auto;
}
.pk-animationthumbnail-items {
  @extend .pk-flex;
  flex-direction: column;
  .pk-animationthumbnail-item {
    margin: 2px;
    width: calc(100% - 4px);
    color: rgb(65, 130, 184);
    border-radius: 3px;
    @extend .pk-flex;
    flex-direction: row;
    
    .pk-animationthumbnail-item-title {
      margin-left: 3px;
      cursor: pointer;
      flex-grow: 1;
    }
    .pk-animationthumbnail-item-standalone-button {
      width: 20px;
      background-image: url('../../assets/icons/open-in-new-page.png');
      background-size: contain;
      background-repeat: no-repeat;
      cursor: pointer;
    }
    .pk-animationthumbnail-item-standalone-button:hover {
      background-image: url('../../assets/icons/open-in-new-page-hover.png');
    }
  }
  .showing {
    background-color: rgb(96, 136, 168);
    color: rgb(255, 255, 255);
  }
  .pk-animationthumbnail-item:hover {
    background-color: rgb(39, 93, 138);
    color: rgb(199, 199, 199);
  }
}

</style>
